import { Common } from '~/models/common';
import { Menu } from '~/models/menu';

export const menuService = {
	fetch: async (): Promise<Menu.Model[]> => {
		const params = {
			filter: {
				status: Common.Status.PUBLISHED,
			},
			fields: ['*', 'to.url'],
		};

		try {
			const response = await $fetch<Menu.Model[]>(Menu.api, {
				method: 'POST',
				body: { params },
			});

			return response;
		} catch (error) {
			console.error('Failed to fetch Menu:', error);

			return [];
		}
	},
};
